
import { Card } from "@/components/ui/card";

const SellerNotifications = () => {
  return (
    <div className="container mx-auto px-4 py-6 max-w-2xl">
      <Card className="p-6">
        <p className="text-muted-foreground">Notification settings coming soon...</p>
      </Card>
    </div>
  );
};

export default SellerNotifications;
